import React from 'react';
import { t } from 'i18next';
import { TicketStatus } from './TicketTypes';

// Render the status of a ticket as a badge, a new reply of the requester shows as such
export const renderTicketStatusBadge = (status: TicketStatus, newReply?: boolean, small: boolean = false) => {
    const showReply = newReply && status !== 'new' && status !== 'resolved';
    const badgeClass = showReply ? 'ticket-reply' : `ticket-${status}`;
    const label = showReply ? t('ticket.status.new_reply') : t(`ticket.status.${status}`);

    return (
        <div className='badge-container'>
            <div className={`status-badge ${badgeClass} ${small ? 'small' : ''}`}>
                {label}
            </div>
        </div>
    );
};
